import styles from "./index.module.scss";
export default function ProfileHeaderBar() {
  return <div className={styles.ProfileBarWrap}>Profile</div>;
}
